import React from "react";
import Footer from "../../components/footer/Footer";
import JokerProHeader from "../../components/header/JokerVideoHeader";
import AssetsPack from "../../util/AssetsPack";
import { useTranslation } from "react-i18next";
import style from "./JokerSupport.module.css";
// import SupportSection from "./component/SupportSection";
// import SupportButton from "./component/SupportButton";

import MainTemplate from "../Templates/MainTemplate";
import FAQ from "./component/FAQ";
import { supportInformationSectionItems } from "../../util/CollectionData";
import InformationSection from "../../components/InformationSection";
import { ButtonType, JokerButton } from "material-ui-jokerpro";
import { toast } from "react-toastify";

const JokerSupport = () => {
  const { t } = useTranslation();

  const header = (
    <JokerProHeader
      headerText={t("nav_bar.support")}
      title={t("joker_support.title_1")}
      highlightLabel={t("joker_support.title_2")}
      description={t("joker_support.sub_title")}
      bgImage={AssetsPack.image.BG_JOKER_SUPPORT_HEADER}
      image={AssetsPack.image.JOKER_SUPPORT_HEADER}
      isDownloadTagNotVisible
    >
      <>
        <JokerButton
          text={"Talk to an agent"}
          onClick={() => {
            toast.info("Coming Soon", {
              icon: (
                <img
                  src={AssetsPack.icons.ICON_BELL.default}
                  alt="warn icon"
                  style={{ width: 20, height: 20 }}
                />
              ),
            });
          }}
          disabled
          type={ButtonType.CTA}
          icon={`${AssetsPack.icons.REDIRECT_ARROW.default}`}
        />
      </>
    </JokerProHeader>
  );

  const body = (
    <div className={style["body-container"]}>
      {/* <div className={style["support-button-container"]}>
        <SupportButton buttons={supportButtons} />
      </div> */}
      {/* <div className={style["support-container"]}>
        <SupportSection
          imageUrl={AssetsPack.images.JOKER_SUPPORT_WOMAN_HEADSET}
        />
      </div> */}
      <div className={style["faq-container"]}>
        <FAQ />
      </div>

      <div className={style["information-section-container"]}>
        <InformationSection
          titleTone1={t("joker_support.simplify_journey.title_tone_1")}
          titleTone2={t("joker_support.simplify_journey.title_tone_2")}
          description={t("joker_support.simplify_journey.description")}
          items={supportInformationSectionItems()}
          isHovered
        />
      </div>
    </div>
  );

  return (
    <MainTemplate
      body={body}
      footer={<Footer />}
      header={header}
      fullWidthHeaderIpad
    />
  );
};

export default JokerSupport;
